import * as types from "./mutation-types";

const mutations = {
  [types.SET_PROGRAM_REGISTRATION_FIELDS](state, programRegistrationFields) {
    state.programRegistrationFields = programRegistrationFields;
  },

  [types.SET_LOADED_STATUS](state, data) {
    state[data.key] = data.value;
  },

  [types.SET_CREATE_TEAM_AFTER_SIGN_IN](state, data) {
    state.createTeamAfterSignIn = data.value;
  },

  [types.SET_CREATE_TEAM_FORM_DATA](state, data) {
    state.createTeamFormData = data.value;
  }
};

export default mutations;
